import { CalendarGreyIcon, ClocckGreyIcon, CloseGreyIcon, ReservationGreyIcon, TicketsGreyIcon } from "../../../assets/icons";
import { LocalEventDTO } from "../../../models/local/local.response";
import { ToLocalDateString, ToLocalTimeString } from "../../../utils/dateFormater";

interface LocalEventViewProps {
    localEvent: LocalEventDTO;
    onClose: () => void;
}

export default function LocalEventView({ localEvent, onClose }: LocalEventViewProps) {

    return (
        <section className="local-event-section" onClick={onClose}>
            <div className="w-layout-blockcontainer container w-container">
                <div className="local-event-wrapper">
                    <div className="local-event-modal-block" onClick={(e) => e.stopPropagation()}>
                        <div className="div-block-135">
                            <img src={localEvent.imageUrl + "@lg.webp"} loading="lazy" alt="" className="def-image" />

                            {/* <div className="div-block-136">
                                <div className="div-block-137">
                                    <img src="https://cdn.prod.website-files.com/6919e066813f7ba31cee91ac/695c5867ad7fc999c8982196_booking.png" loading="lazy" alt="" className="icon-size-24" />
                                    <div>14. JUN 2026.</div>
                                </div>
                                <div className="div-block-137">
                                    <img src="https://cdn.prod.website-files.com/6919e066813f7ba31cee91ac/695c5867ad7fc999c8982196_booking.png" loading="lazy" alt="" className="icon-size-24" />
                                    <div>20:00 - 01:00</div>
                                </div>
                                <div className="div-block-137">
                                    <img src="https://cdn.prod.website-files.com/6919e066813f7ba31cee91ac/695c5867ad7fc999c8982196_booking.png" loading="lazy" alt="" className="icon-size-24" />
                                    <div>Test Local Pub</div>
                                </div>
                            </div> */}

                            <div className="event-modal-close-mobile" onClick={onClose}>
                                <img src={CloseGreyIcon} loading="lazy" alt="" className="icon-size-16" />
                            </div>

                        </div>
                        <div className="div-block-140">
                            <div className="div-block-141" onClick={onClose}>
                                <img src={CloseGreyIcon} loading="lazy" alt="" className="icon-size-16" />
                            </div>
                            <div className="local-event-modal-title">{localEvent.title}</div>
                            <div className="local-event-modal-description">{localEvent.description}</div>

                            <div className="div-hr"></div>
                            <div className="local-event-modal-info-div">
                                <div className="div-block-139">
                                    <img src={CalendarGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                                    <div>Datum</div>
                                </div>
                                <div>{ToLocalDateString(localEvent.startsAtUtc)}</div>
                            </div>

                            <div className="div-hr"></div>
                            <div className="local-event-modal-info-div">
                                <div className="div-block-139">
                                    <img src={ClocckGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                                    <div>Vreme</div>
                                </div>
                                <div>{ToLocalTimeString(localEvent.startsAtUtc)} - {ToLocalTimeString(localEvent.endsAtUtc)}</div>
                            </div>

                            {localEvent.priceText && (
                                <>
                                    <div className="div-hr"></div>
                                    <div className="local-event-modal-info-div">
                                        <div className="div-block-139">
                                            <img src={TicketsGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                                            <div>Ulaz</div>
                                        </div>
                                        <div>{localEvent.priceText}</div>
                                    </div>
                                </>
                            )}

                            {localEvent.reservationUrl && (
                                <>
                                    <div className="div-hr"></div>
                                    <div className="local-event-modal-info-div">
                                        <div className="div-block-139">
                                            <img src={ReservationGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                                            <div>Rezervacije</div>
                                        </div>
                                        <div className="button-primary" onClick={() => window.open(localEvent.reservationUrl, "_blank")}>
                                            <div>Rezerviši</div>
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className="div-hr"></div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}